import API, { API as Instance} from './API';

const path = `objetos-postais`;

const ObjetoPostalService = {
    // FILTROS
    filters: async filters => await API.filters(path, filters),

    // EXPORTAR
    export: async filters => await API.export(path, filters),

    // LISTAR TODOS
    list: async () => await API.list(path),

    // LISTAR ENUM STATUS
    listStatus: async () => await API.list(`${path}/status`),

    // POR DATA
    porData: async filters => await API.filters(`${path}/por-data`, filters), 
    porDataExport: async filters => await API.export(`${path}/por-data`, filters), 

    // POR STATUS
    porStatus: async filters => await API.filters(`${path}/por-status`, filters), 
    porStatusExport: async filters => await API.export(`${path}/por-status`, filters), 

    atualizar: async numero => await Instance.put(`${path}/atualizar/${numero}`),
    marcarEntrega: async numero => await Instance.put(`${path}/${numero}/marcar-entrega`),
}

export const ObjetoPostalErroService = {
    // FILTROS
    filters: async filters => await API.filters(`${path}/erros`, filters),

    // EXPORTAR
    export: async filters => await API.export(`${path}/erros`, filters),

    // LISTAR TODOS
    list: async () => await API.list(`${path}/erros`),
}

export default ObjetoPostalService;